import { CKEditor } from "ckeditor4-react";
import React, { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";

export function WrapperTextInput(props) {
    // https://react-bootstrap-v4.netlify.app/components/forms/#form-control-props

    if (!["text", "number", "email", undefined].includes(props.type)) {
        return <div style={{ color: "red" }}>WrapperTextInput error for type: '{props.type}'</div>;
    }
    const newProps = { ...props };
    newProps.type ||= "text";
    if (newProps.value === null || newProps.value === undefined) {
        newProps.value = "";
    }
    return <Form.Control dir="auto" {...newProps} />;
}

export function WrapperTextArea(props) {
    // https://react-bootstrap-v4.netlify.app/components/forms/#form-control-props

    if (!props.name) {
        return <div className="text-danger">WrapperTextArea error</div>;
    }

    const newProps = { ...props };
    if (newProps.value === null || newProps.value === undefined) {
        newProps.value = "";
    }
    if (newProps.innerRef) {
        newProps.ref = newProps.innerRef;
        delete newProps.innerRef;
    }
    return <Form.Control as="textarea" dir="auto" {...newProps} />;
}

export function WrapperCKEditor({ prefix, apiData, setApiData, name, onChange }) {
    // https://ckeditor.com/docs/ckeditor4/latest/guide/dev_react_current.html

    const didMount = useRef();
    const form = apiData.forms_data[prefix];
    const [val, setVal] = useState(form.data[name]);

    const { config } = form.fields[name].widget;
    if (form.fields[name].disabled) {
        config.readOnly = true;
    }
    // Добавляем CSS для спойлера в iframe редактора через событие onInstanceReady
    const onInstanceReady = (evt) => {
        const editor = evt.editor;
        const doc = editor.document.$;
        const link = doc.createElement("link");
        link.rel = "stylesheet";
        link.href = "/showcasestatic/ckeditor/ckeditor/plugins/spoiler/css/spoiler.css";
        doc.head.appendChild(link);
    };

    useEffect(() => {
        if (!didMount.current) {
            didMount.current = true;
            return;
        }
        if (val || name in form.data) {
            // костыль, если на странице с локалями есть одинаковые ckeditor поля
            // то при переключении между локалями data выставляется в ''
            // даже если в локали вообще ничего не заполнено, поэтому проверяем
            onChange({ prefix, apiData, setApiData, name, val });
        }
    }, [val]);

    useEffect(() => {
        // костыль, если на странице с локалями есть одинаковые ckeditor поля
        // то при переключении между локалями данные поля переносятся из локали в локаль
        if (window.CKEDITOR) {
            if (Object.keys(window.CKEDITOR.instances).length === 1) {
                const editor = Object.keys(window.CKEDITOR.instances)[0];
                window.CKEDITOR.instances[editor].setData(form.data[name]);
            }
            window.CKEDITOR.instances.editor1 && window.CKEDITOR.instances.editor1.setData(form.data[name]);
        }
    }, [prefix]);

    return (
        <CKEditor
            config={config}
            initData={val}
            onChange={(ev) => setVal(ev.editor.getData())}
            onInstanceReady={onInstanceReady}
            editorUrl="/showcasestatic/libs/ckeditor/4.21.0/ckeditor.js"
        />
    );
}
